<template>
    <div class="login-welcome">
        <PhoneInput
            ref="phoneInput"
            class="login-welcome__phone"
            v-model="authenticationData.userName"
            name="phone"
            :disabled="true"
            v-model:error-message="authenticationErrors.phoneErrorMessage"
        />
        <PasswordInput
            ref="passwordInput"
            class="login-welcome__password"
            v-model="authenticationData.password"
            name="password"
            v-model:error-message="authenticationErrors.passwordErrorMessage"
            :focus="true"
        />
    </div>
</template>

<script setup lang="ts">
import PasswordInput from "@/account/components/inputs/password-input.vue";
import PhoneInput from "@/account/components/inputs/phone-input.vue";
import { authenticationErrors, authenticationData } from "@/account/composables/use-authentication-data";

import { ref } from "vue";

const phoneInput = ref(null);
const passwordInput = ref(null);

const checkIfIsValid = async () => {
    return phoneInput.value.checkIfIsValid() && passwordInput.value.checkIfIsValid();
};

defineExpose({
    checkIfIsValid,
});
</script>
